import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  ListItem,
  Text,
  Tooltip,
  UnorderedList,
} from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

import { Card } from 'components/common/Card'
import { SubscriptionTier } from 'generated/generated-graphql'
import { useRegion } from 'providers/RegionProvider'
import { getLocaleFormattedPrice } from 'utils/price'

import { SubscriptionCardProps } from './SubscriptionCard'

export const SubscriptionCardSpain = ({
  title,
  tier,
  price,
  buttonTooltipText,
  isDisabled,
  bulletPoints = [],
  onSubscriptionPlanClick,
}: SubscriptionCardProps) => {
  const { t } = useTranslation('common')
  const { region } = useRegion()

  return (
    <Card
      w={{ base: 'full', xl: '400px' }}
      variant="subscription"
      p="32px"
      contentBoxProps={{ m: 0, h: 'full' }}
    >
      <Flex direction="column" alignItems="start" position="relative" h="full">
        <Text
          color="brand.ultramarine"
          fontSize="24px"
          lineHeight="28px"
          fontFamily="Proxima Nova Semibold"
        >
          {title}
        </Text>

        {price && tier !== SubscriptionTier.Enterprise ? (
          <HStack h="40px" mt="20px" spacing="12px" align="baseline">
            <Text w="full" fontSize="24px" lineHeight="20px" fontWeight={600}>
              {t('BRAND_PROFILE_SUBSCRIPTION_STANDARD_PRICE', {
                price: getLocaleFormattedPrice({
                  price,
                  region,
                }),
              })}
            </Text>
          </HStack>
        ) : null}

        <UnorderedList mt="12px" spacing="8px" textAlign="left">
          {bulletPoints.map((bulletPoint) => (
            <ListItem
              key={bulletPoint}
              w="full"
              fontSize="18px"
              lineHeight="20px"
            >
              {t(bulletPoint)}
            </ListItem>
          ))}
        </UnorderedList>

        <Box marginTop="auto" w="full">
          <Divider mt="30px" mb="24px" w="full" />

          <Tooltip label={buttonTooltipText}>
            <Box w="full">
              <Button
                isDisabled={isDisabled}
                variant="lightBlue"
                w="full"
                h="50px"
                onClick={() => {
                  onSubscriptionPlanClick?.(tier)
                }}
              >
                {tier === SubscriptionTier.Enterprise
                  ? t('BRAND_PROFILE_SUBSCRIPTION_CONTACT')
                  : t('VENUE_PAGE_TEXT32')}
              </Button>
            </Box>
          </Tooltip>
        </Box>
      </Flex>
    </Card>
  )
}
